export const parseQueryString = (query = '') => {
  if (!query) {
    return {};
  }

  query = query.trim();

  if (query.startsWith('?')) {
    query = query.slice(1);
  }
  const queryArray = query.split('&');
  return queryArray.reduce((prev, item) => {
    const [itemKey, itemValue] = item.split('=');

    if (!itemKey || !itemValue) {
      return;
    }

    const bracketsRegex = /\[.*]/g;
    if (bracketsRegex.test(itemKey)) {
      let index = itemKey.match(bracketsRegex)[0];
      index = index.replace(/(\[|])/g, '');
      const key = itemKey.replace(bracketsRegex, '');
      if (index) {
        if (!prev[key]) {
          prev[key] = {};
        }
        prev[key][index] = itemValue;
      } else {
        if (!prev[key]) {
          prev[key] = [];
        }
        prev[key].push(itemValue);
      }
    } else {
      prev[itemKey] = itemValue;
    }
    return prev;
  }, {});
};
